/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const StationsFiltersTypeEnum = {
    STATION_TYPE: "STATION_TYPE"
} as const;

export type StationsFiltersTypeEnumKey = (typeof StationsFiltersTypeEnum)[keyof typeof StationsFiltersTypeEnum];

export const StationsFiltersValueEnum = {
    STANDALONE: "STANDALONE",
    HEADER: "HEADER",
    REPEATER: "REPEATER",
    AFFILIATE: "AFFILIATE"
} as const;

export type StationsFiltersValueEnumKey = (typeof StationsFiltersValueEnum)[keyof typeof StationsFiltersValueEnum];

export const StationsFiltersTypeEnum2 = {
    STATION_GROUP: "STATION_GROUP"
} as const;

export type StationsFiltersTypeEnum2Key = (typeof StationsFiltersTypeEnum2)[keyof typeof StationsFiltersTypeEnum2];

export const StationsFiltersTypeEnum3 = {
    STATION_INDIVIDUAL: "STATION_INDIVIDUAL"
} as const;

export type StationsFiltersTypeEnum3Key = (typeof StationsFiltersTypeEnum3)[keyof typeof StationsFiltersTypeEnum3];

/**
 * @description Data DTO for GIP report queries
*/
export type GipReportDataDto = {
    /**
     * @description The unique identifier of the client
     * @type string | undefined, uuid
    */
    clientId?: string;
    /**
     * @description Array of station IDs to query. Either this field or stationsFilters must be provided, but not both. Empty array will return all client stations.
     * @type array | undefined
    */
    stationsIds?: string[];
    /**
     * @description Array of station filters to apply. Either this field or stationsIds must be provided, but not both. Empty array will return all client stations.
     * @type array | undefined
    */
    stationsFilters?: ({
        /**
         * @type string
        */
        type: StationsFiltersTypeEnumKey;
        /**
         * @type string
        */
        value: StationsFiltersValueEnumKey;
    } | {
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum2Key;
        /**
         * @type string, uuid
        */
        value: string;
    } | {
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum3Key;
        /**
         * @type string, uuid
        */
        value: string;
    })[];
    /**
     * @description Start date/time for the report period (ISO 8601 with or without timezone)
     * @type string
    */
    from: string;
    /**
     * @description End date/time for the report period (ISO 8601 with or without timezone)
     * @type string
    */
    to: string;
    /**
     * @description Array of campaign names to filter by
     * @type array | undefined
    */
    campaigns?: string[];
    /**
     * @description Array of advertiser names to filter by
     * @type array | undefined
    */
    advertisers?: string[];
    /**
     * @description Array of version identifiers to filter by
     * @type array | undefined
    */
    versions?: string[];
    /**
     * @description Custom key-value pairs for additional filtering
     * @default [object Object]
     * @type object | undefined
    */
    customFields?: {
        [key: string]: string;
    };
    /**
     * @description Array of audio IDs to filter by
     * @type array | undefined
    */
    audioIds?: string[];
    /**
     * @description Array of custom IDs to filter by
     * @type array | undefined
    */
    customIds?: string[];
    /**
     * @description Array of order identifiers to filter by
     * @type array | undefined
    */
    orders?: string[];
    /**
     * @description Array of match IDs to exclude from the report
     * @type array | undefined
    */
    excludedMatches?: string[];
};